
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../../redux/MultiselectRows"
import Pagination from "../../../components/Pagination"
import Limit from "../../../components/Limit"
import GlobalContext from "../../../components/Context/GloablContext"
import CustomOverLay from "../../../components/CustomOverLay"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import Emptyscreen from "../../../components/EmptyScreen"
import ConfirmationPrompt from "../../../components/ConfirmationPrompt"
import AnimatedModel from "../../../components/Animation/AnimatedModel"
import { useEditPatientMutation } from "../../../features/patientSlice"
import { useExportWellnessNotesListMutation } from "../../../features/alertSlice"
import { handleAddFilterValues } from "../../../redux/systemConfigSlice"
import PatientTable from "./Component"
import moment from "moment"
import { convertDatesToEpochUTC } from "../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import TopBarPatient from "./TopBar"
import { useGetWellnessNotesListQuery } from "../../../features/alertSlice"
import { handleTotalUsers as handleTotalPatients, resetOrgList } from "../../../redux/wellnessFilterSlice"
import { resetOrgList as resetOrgUserList } from "../../../redux/wellnessFilterUserSlice"
import { handleTotalUsers } from "../../../redux/wellnessFilterUserSlice"
import { dataService } from "../../../services/data.services"
import WellnessReportSearch from "./AdvancedSearch"
import { setWellnessReportSearchApplied } from "../../../redux/wellnessReportSearchSlice"

export default function ManageWellnessReports() {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar, isAdvancedSearchOpen } = useContext(GlobalContext);
    const wellnessReportSearch = useSelector(state => state.WellnessReportSearchData);

    const [editPatient] = useEditPatientMutation()
    const [exportWellnessNotes] = useExportWellnessNotesListMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const auth = useSelector(state => state?.auth)
    const orgId = useSelector(state => state?.systemConfigData?.organization_id)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const { userType } = auth
    const initialState = {
        "start_date": searchParams?.get('start_date') ? `${new Date(parseInt(searchParams?.get('start_date')) * 1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('start_date')) * 1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('start_date')) * 1000).getDate()).padStart(2, '0')}` : new Date(),
        "end_date": searchParams?.get('end_date') ? `${new Date(parseInt(searchParams?.get('end_date')) * 1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('end_date')) * 1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('end_date')) * 1000).getDate()).padStart(2, '0')}` : new Date(),
        'status': []
    }
    const [filterValues, setFilterValues] = useState(initialState)
    const [datePartialFilled, setDatePartialFilled] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const { data, isFetching, isLoading, status } = useGetWellnessNotesListQuery(searchParams?.toString(), { skip: searchParams?.size < 7 || location.search === '' })
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
            params.last_page = null
            params.last_id = null
        }
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }

    const handleDispatch = useCallback(() => {
        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            let params = {};
            if (location?.state?.search !== '') {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'search': decodeURIComponent(location.state.search),
                    'last_id': null,
                    'last_page': null
                }
            } else {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'last_id': null,
                    'last_page': null
                }
            }
            // Set search params directly to preserve pagination state from navigation
            setSearchParams({ ...params })
        }
        else {
            // Only initialize default values if no search params exist
            if (!searchParams.get('limit')) {
                handleSearchParams('limit', '15')

            }
            if (!searchParams.get('page_number')) {
                handleSearchParams('page_number', '1')
            }
            if (!searchParams.get('start_date')) {
                handleSearchParams('start_date', convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, true))
            }
            if (!searchParams.get('end_date')) {
                handleSearchParams('end_date', convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, false))
            }
            if (!searchParams.get('filter')) {
                handleSearchParams('filter', "true")
            }
            if (!searchParams.get('last_id')) {
                data === undefined ? handleSearchParams('last_id', null) : handleSearchParams('last_id', data?.data?.[data?.data?.length - 1]?._id);
            }
            if (!searchParams.get('last_page')) {
                handleSearchParams('last_page', null)
            }
        }
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
    }, [location]);

    useEffect(() => {
        handleDispatch()

    }, [handleDispatch]);

    useEffect(() => {
        fetchData()
    }, [filterValues?.start_date, filterValues?.end_date])

    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        params['last_id'] = null
        params['last_page'] = null
        setSearchParams({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum, last_id: (pageNum === 1 ? null : searchParams?.get('page_number') > pageNum ? (data?.data?.[0]?._id !== undefined ? data?.data[0]?._id : null) : (data?.data?.[data?.data?.length - 1]?._id !== undefined ? data?.data[data?.data?.length - 1]?._id : null)), last_page: (pageNum === 1 ? null : searchParams?.get('page_number') > pageNum ? searchParams?.get('page_number') : searchParams?.get('page_number')) })
    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const fetchData = async () => {
        try {
            let res
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=patient&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, false)}&dropdown_type=wellness&page_number=${1}&limit=20`)
            if (res.data.status === 200) {
                dispatch(handleTotalPatients([res?.data?.data?.total_count]))
            }
            res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=user&start_date=${convertDatesToEpochUTC(moment(filterValues?.start_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, true)}&end_date=${convertDatesToEpochUTC(moment(filterValues?.end_date).format('YYYY-MM-DD'), Intl.DateTimeFormat().resolvedOptions().timeZone, false)}&dropdown_type=wellness&page_number=${1}&limit=20`)
            if (res.data.status === 200) {
                dispatch(handleTotalUsers([res?.data?.data?.total_count]))
            }

        } catch (error) {
        }
    };

    useEffect(() => {
        return (() => {
            dispatch(resetOrgList())
            dispatch(resetOrgUserList())
        })
    }, [])

    const handleChange = (val) => {
        handleSearchParams('search', val)
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        const start_date = moment(filterValues?.start_date).format('YYYY-MM-DD')
        const end_date = moment(filterValues?.end_date).format('YYYY-MM-DD')
        if (type) {
            // params.filter = "true";
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                "start_date": filterValues.start_date,
                "end_date": filterValues.end_date,
                'organization_name': filterValues.organization_name,
            }));

            params.page_number = 1
            params.last_page = null
            params.last_id = null
            filterValues?.organization_name !== "" && filterValues?.organization_name !== undefined ? params["organization_name"] = filterValues.organization_name : ''
            filterValues?.start_date !== "" && filterValues?.start_date !== undefined ? params["start_date"] = convertDatesToEpochUTC(start_date, Intl.DateTimeFormat().resolvedOptions().timeZone, true) : ''
            filterValues?.end_date !== "" && filterValues?.end_date !== undefined ? params["end_date"] = convertDatesToEpochUTC(end_date, Intl.DateTimeFormat().resolvedOptions().timeZone, false) : ''
            params.filter = "true";
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                "start_date": '',
                "end_date": '',
                "organization_name": "",
            });

            // Remove filter-related keys from searchParams

            // delete params['filter'];
            params["organization_name"] && delete params["organization_name"]
            params.start_date && delete params.start_date
            params.end_date && delete params.end_date
            if (params["filter"] === "true") {
                delete params["filter"];
            }

            setSearchParams({ ...params });
        }
    };

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async (e) => {

        if ((confirmationState?.rowData !== undefined && confirmationState?.rowData !== "" && confirmationState?.rowData?.status === 'active' && textAreaMsg.trim() === '') || (confirmationState?.multirow === "deactive" && (textAreaMsg.trim() === ''))) {
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = {}
            if (confirmationState?.rowData !== undefined && confirmationState?.rowData !== "") {
                {
                    confirmationState?.rowData?.status === 'inactive' ?
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": ''
                        } :
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        }
                }
            }
            else {
                confirmationState?.multirow === "deactive" ?
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg
                    }
                    :
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": ''

                    }
            }
            setLoading(true)

            const activationRes = await editPatient({ body })
            setLoading(false)

            if (activationRes?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                if (confirmationState?.multirow !== "" && confirmationState?.multirow !== undefined) {
                    setToastmessage(`Patients ${confirmationState?.multirow === "active" ? "activated" : "deactivated"} successfully`);
                }
                else {
                    setToastmessage(`Patient ${confirmationState?.rowData?.status === "inactive" ? "activated" : "deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})

        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    // apply search function
    const handleOnSubmit = (e) => {

        e.preventDefault();

        let searchString = '';

        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `patient_id` and `patient_id_inverse` conditions
        if (wellnessReportSearch?.patient_id && wellnessReportSearch.patient_id.trim() !== '') {
            const patientIdPrefix = wellnessReportSearch.patient_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(wellnessReportSearch.patient_id);
            searchString += `patient_id=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }

        // check for acknowledge user id field 
        if (wellnessReportSearch?.user_id && wellnessReportSearch.user_id.trim() !== '') {
            const userIDPrefix = wellnessReportSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserID = formatSearchValue(wellnessReportSearch.user_id);
            searchString += `user_id=${userIDPrefix}${encodeURIComponent(formattedUserID)};`;
        }

        // check for acknowledge user id field 
        if (wellnessReportSearch?.notes && wellnessReportSearch.notes.trim() !== '') {
            const notesPrefix = wellnessReportSearch.notes_inverse ? 'ne:' : '';
            const formattednotes = formatSearchValue(wellnessReportSearch.notes);
            searchString += `description=${notesPrefix}${encodeURIComponent(formattednotes)};`;
        }

        const { duration_hours, duration_minutes, duration_seconds } = wellnessReportSearch;

        // Check if all duration fields are empty
        const isDurationEmpty =
            (!duration_hours || duration_hours.trim() === '') &&
            (!duration_minutes || duration_minutes.trim() === '') &&
            (!duration_seconds || duration_seconds.trim() === '');

        if (!isDurationEmpty) {  // Only process if at least one field is filled
            // Fill empty fields with '*'
            const formattedHours = duration_hours && duration_hours.trim() !== '' ? duration_hours : '*';
            const formattedMinutes = duration_minutes && duration_minutes.trim() !== '' ? duration_minutes : '*';
            const formattedSeconds = duration_seconds && duration_seconds.trim() !== '' ? duration_seconds : '*';

            const isAllFieldsDash = formattedHours === '-' && formattedMinutes === '-' && formattedSeconds === '-';
            const isAllFieldsStar = formattedHours === '*' && formattedMinutes === '*' && formattedSeconds === '*';
            const isAllFieldsFilled =
                formattedHours !== '-' && formattedHours !== '*' &&
                formattedMinutes !== '-' && formattedMinutes !== '*' &&
                formattedSeconds !== '-' && formattedSeconds !== '*';

            // Replace dashes (-) with __NULL__
            const finalHours = formattedHours === '-' ? '__NULL__' : formattedHours;
            const finalMinutes = formattedMinutes === '-' ? '__NULL__' : formattedMinutes;
            const finalSeconds = formattedSeconds === '-' ? '__NULL__' : formattedSeconds;

            // Construct formatted duration
            let formattedDuration = `${finalHours} Hrs:${finalMinutes} Mins:${finalSeconds} Secs`;
            let durationPrefix = wellnessReportSearch?.duration_inverse ? 'ne:' : '';  // Apply "ne:" if inverse is true

            if (isAllFieldsDash) {
                searchString += `end_time=${durationPrefix}__NULL__;`;
            } else if (isAllFieldsStar) {
                searchString += `end_time=${durationPrefix}*;`;
            } else if (isAllFieldsFilled) {
                let formattedWithBrackets = `*${formattedDuration}*`;
                searchString += `end_time=${durationPrefix}${encodeURIComponent(formattedWithBrackets)};`;
            } else {
                let formattedWithBrackets = `*${formattedDuration}*`;
                searchString += `end_time=${durationPrefix}${encodeURIComponent(formattedWithBrackets)};`;
            }
        }

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: wellnessReportSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            last_id: null, // Reset last_id on new search
            last_page: null, // Reset last_page on new null
            limit: currentParams.limit || '15', // Keep limit or set default
        };

        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;

        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        setisSortSelected(false)
        dispatch(setWellnessReportSearchApplied());

    };

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Wellness Reports"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarPatient
                            title={'List of Wellness Reports'}
                            SearchInput={((data?.data?.length === 0 && searchParams.get("search") === null) || data === undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Patient"}
                            menuBar={(data !== undefined && data?.data?.length > 0 && selectedRows?.length > 0) ? true : false}
                            ApplyFilter={((searchParams.get('unselected_patient_ids') === null) && (searchParams.get('selected_patient_ids') === null) && (searchParams.get('unselected_user_ids') === null) && (searchParams.get('selected_user_ids') === null) && (searchParams.get('status') === null) && data?.data?.length === 0) || (data === undefined) ? false : true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-patients/add-patients'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            isExport={true}
                            exportCols={['Timestamp', 'User ID', 'User Name', 'Patient ID', 'Patient Name', 'Status', 'Duration', 'Notes']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportPatient={exportWellnessNotes}
                            filterValues={filterValues}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            TotalCount={parseInt(data?.total_count)}

                        // isIdexport={true}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected") || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Wellness Details..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay-wellness' : 'overlay-list-wellness'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <PatientTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}

                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {(data?.total_count === 0 && suggestions?.trim() !== "") || (data?.success_status === "false") ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            : (data?.total_count === 0 && suggestions?.trim() !== "") || (data?.success_status === "false") || (searchParams.get('start_date') !== null || searchParams.get('end_date') !== null || searchParams.get('organization_name') !== null) ?
                                <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} />
                                :
                                data?.total_count === 0 && !searchParams.get("search") ? <Emptyscreen
                                    title={"Manage Patients"}
                                    FirstPTag={"No Patients associated yet ."}

                                /> : ((status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) && <SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                disabled={loading}
                                tittle={confirmationState?.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === "active" ? 'Activate' : 'Deactivate'}
                                message={confirmationState.rowData !== "" ? `Are you sure you want to ${confirmationState?.rowData?.status === "inactive" ? 'activate' : 'deactivate'} the patient?` :
                                    `Are you sure you want to ${confirmationState.multirow === 'active' ? 'activate' : 'deactivate'} the following patients?`}
                                textMessage={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === 'inactive' ? true : false : confirmationState.multirow === "active" ? true : false}
                                buttonName={confirmationState.rowData !== "" ? confirmationState?.rowData?.status === "inactive" ? 'Activate' : 'Deactivate' : confirmationState.multirow === 'active' ? 'Activate' : 'Deactivate'}
                                userList={confirmationState?.multirow === '' ? '' : confirmationState?.multirow === "deactive" ? (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name) : (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name)}
                                loadingActivation={loading}
                            />
                        }
                    />
                }
                {isAdvancedSearchOpen && searchParams?.get('limit') && !searchParams?.get('target_user_name') &&
                    <WellnessReportSearch
                        handleOnSubmit={handleOnSubmit}
                        emptyField={datePartialFilled}
                        setEmptyField={setDatePartialFilled}
                        providerAlertsSearch={true}
                    />
                }
            </div>
        </>

    )
}